import BandMathIcon from '@apps-common/ui-icons/Bandmath.jsx';

export default BandMathIcon;
